import { Injectable } from '@angular/core';
import { DataSourceRequestState, SortDescriptor, DataResult, translateDataSourceResultGroups } from '@progress/kendo-data-query';
import { Observable, of } from 'rxjs';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';

@Injectable({
  providedIn: 'root'
})
export class ServiceItemService {

  constructor(
    private auth: AuthService,
    private httpRepo: HttpRepo,
    private commonMethod: CommonMethods
  ) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
   }

  public fetchServiceItems(serviceItemData:any,state: DataSourceRequestState, sort:SortDescriptor[]): Observable<DataResult> 
  {
    const hasGroups = state.group && state.group.length;
    return of({data: serviceItemData.LaborItems,total:serviceItemData.Count}) // Send the state to the server
        .map(({data, total} : GridDataResult) => // Process the response
            (<GridDataResult>{
                data: hasGroups ? translateDataSourceResultGroups(data) : data,
                total: total,
            })
        )
  }
  GetMaterialItems(state: DataSourceRequestState, searchKey) {
    return this.httpRepo.Get("pricebook/materialitems", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
  }
  SaveServiceItem(data){
    data.ID = CommonMethods.GetID();;
    return this.httpRepo.Post("pricebook/serviceitems",data );
  }
  SaveEditItem(data){
    return this.httpRepo.Put("pricebook/serviceitems/"+data.ID,data );
  }
  GetLaborItems(state: DataSourceRequestState, searchKey) {
    return this.httpRepo.Get("pricebook/laboritems", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
  }
  UploadDocument() {
    return this.httpRepo.AbsoluteURL + "/pricebook/serviceitemsattachment";
  }
  GetServiceItem(ID){
    return this.httpRepo.Get("pricebook/serviceitems/"+ID+"?references=*")
  }
  EditUploadDocument(formData){
    return this.httpRepo.PostFile("pricebook/serviceitemsattachment", formData); //"/pricebook/serviceitemsattachment"
  }
  UploadExternalDocument(val: string){
    return this.httpRepo.Post("pricebook/externalserviceitemsattachment", val);
  }
}
